<section>
    <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
    </div>
  
    <div class="modal-body" style="height:80px">
      {{Message}}
    </div>
</section>
  